import { FieldHookConfig, useField, useFormikContext } from "formik";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import styled, { useTheme } from "styled-components";

import { Typography } from "@sso/ui/Typography";

const Label = styled.p`
  text-transform: capitalize;
  font-size: 0.9rem;
  color: #616161;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.2rem;
  margin-left: 0.2rem;
`;

const FormikEditor = (props: FieldHookConfig<string> & { label: string }) => {
  const theme = useTheme();
  const [field, meta] = useField({ ...props });
  const error = Boolean(meta.touched && meta.error);
  const { setFieldValue } = useFormikContext();

  return (
    <>
      <Label>{props.label}</Label>
      <ReactQuill
        value={field.value}
        onChange={content => {
          setFieldValue(field.name, content);
        }}
        id={props.name}
        theme="snow"
      />
      {error && (
        <Typography color={theme.colors.error.main} size="0.8rem" textAlign="left" margin="0.2rem">
          {meta.error}
        </Typography>
      )}
    </>
  );
};

export default FormikEditor;
